module.exports = __webpack_public_path__ + "img/oztek-logo.46e29234.svg";